import TrainplanService from '@/services/TrainplanService'

export const get = params =>
  TrainplanService.get('/2/train-change', {
    params
  })
